export default __webpack_public_path__ + "e797749bfe067207355f1230d77e519a.svg";